module.exports = __webpack_public_path__ + "img/ad1.333e7264.png";